export const messages = {
  labels: {
    newIndicator: {
      id: 'header.Labels.NewIndicator',
      defaultMessage: 'New',
    },
  },
};
